module.exports = __webpack_public_path__ + "asset/image-ic_category_32-280800fac031d512.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_32.svg
// module id = OiI6
// module chunks = 0